import { render } from "./GeneralForm.vue?vue&type=template&id=9d5efc26&scoped=true"
import script from "./GeneralForm.vue?vue&type=script&lang=js"
export * from "./GeneralForm.vue?vue&type=script&lang=js"

import "./GeneralForm.vue?vue&type=style&index=0&id=9d5efc26&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d5efc26"]])

export default __exports__